import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([_ctx.conditionalClassObject, "indicator"]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.indicatorClicked($event)), ["prevent"]))
  }, null, 2))
}